// Importar las librerías necesarias
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import es from 'date-fns/esm/locale/es';

import axios from 'axios';
import toast from 'react-hot-toast';

const ModalNuevoEgreso = ({ show, handleClose }) => {
	const token = localStorage.getItem('Token');
	const config = {
		headers: {
			xtoken: `${token}`,
		},
	};

	const [egresoData, setEgresoData] = React.useState({
		fecha: '',
		motivo: '',
		monto: 0,
	});

	// Manejar cambios en los campos del formulario
	const handleChange = (e) => {
		const { name, value } = e.target;
		setEgresoData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleSaveData = async (egresoData) => {
		if (!egresoData.fecha || !egresoData.motivo || !egresoData.monto) {
			return toast.error('Debes completar todos los campos para enviar el egreso de dinero');
		}
		const formattedtDate = egresoData.fecha ? format(egresoData.fecha, 'yyyy-MM-dd') : '';
		const numberMonto = Number(egresoData.monto);
		const data = { ...egresoData, fecha: formattedtDate, monto: numberMonto };

		try {
			const res = await axios.post(
				`${process.env.REACT_APP_BACK_URL}/api/cajadiaria/nuevoegreso`,
				data,
				config
			);

			if (res.status === 200) {
				toast.success('Nuevo egreso enviado con éxito');
			} else {
				toast.error(res.data?.msg);
			}
			// Disparar un evento personalizado 'actualizar-producto' cuando se haya actualizado el producto
			const event = new Event('actualizar-caja');
			window.dispatchEvent(event);

			setEgresoData({
				fecha: '',
				motivo: '',
				monto: 0,
			});
			handleClose();
		} catch (error) {
			console.log(error);
			toast.error(error.response.data?.msg);
		}
	};

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header className='headerModalHistorial' closeButton>
				<Modal.Title>Nuevo egreso de caja</Modal.Title>
			</Modal.Header>
			<Modal.Body className='modalConfirmationContainer'>
				{/* Agregar elementos de formulario para cada campo que deseas editar */}

				<label>Fecha</label>
				<DatePicker
					className='form-control shadow'
					selected={egresoData.fecha}
					onChange={(date) => setEgresoData({ ...egresoData, fecha: date })}
					locale={es}
					dateFormat='dd-MM-yyyy'
				/>

				<div>
					<label htmlFor='nombre'>Motivo:</label>

					<input
						className='form-control'
						type='text'
						name='motivo'
						value={egresoData?.motivo}
						onChange={handleChange}
						placeholder='Motivo del egreso'
					/>
				</div>

				<div>
					<label htmlFor='descripcion'>Monto:</label>
					<input
						className='form-control'
						type='number'
						name='monto'
						value={egresoData?.monto}
						onChange={handleChange}
						placeholder='Monto del egreso'
					/>
				</div>

				<div className='divMagicoReset py-2 mt-4'>
					<Button variant='secondary' onClick={handleClose}>
						Cerrar
					</Button>
					<Button
						className='botonModalConfirmacion'
						variant='primary'
						onClick={() => handleSaveData(egresoData)}
					>
						Enviar Egreso
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ModalNuevoEgreso;
